export default "__VITE_ASSET__42265c80__"